import { 
  getPartListByKey, 
  partAdd, 
  partDetail, 
  partEdit, 
  partDelete, 
  partUp, 
  updatePartOrderByDrag,
  getPreview
} from '@/api/part'

import { MODE } from './shared'

function queryPartListByKey (params) {
  return getPartListByKey(params).then(res => {
    let data = res.data || {}
    return data
  }).catch(_ => _)
}

function addPart (data) {
  return partAdd(data).then(res => res).catch(_ => _)
}

function editPart (data) {
  return partEdit(data).then(res => res).catch(_ => _)
}

function deletePart (data) {
  return partDelete(data).then(res => res).catch(_ => _)
}

function upPart (data) {
  return partUp(data).then(res => res).catch(_ => _)
}

function getPartDetail (uuid) {
  return partDetail(uuid).then(res => res.data || {}).catch(_ => _)
}

function updatePartOrder (data) {
  return updatePartOrderByDrag(data).then(res => res).catch(_ => _)
}

// APP 配置预览api
// 以下接口 来源于 app
// function queryCarouselList () {
//   return getCarouselList().then(res => res.data || []).catch(_ => _)
// }



function formatMode (mode) {
  const modeMap = {
    '1': MODE.ONE,
    '2': MODE.TWO,
    '3': MODE.THREE,
    '4': MODE.FOUR
  }
  return modeMap[mode] || 'UNKNOW'
}

function queryPreivew () {
  return getPreview().then(res => {
    let data = []
    if (res && res.data) {
      data = res.data.map(item => {
        item._mode = formatMode(item.showType)
        item.configList = item.configList || []
        item.configList.forEach(item => {
          item._imgSrc = item.coverUrl
          item._subTitle = item.videoName || ''
          item._date = item.onlineTime || ''
          item._clickNum = item.watchNum || 0
        })
        if (item._mode === MODE.TWO) {
          if (item.configList.length > 3) {
            let _configList = [
              [ ...item.configList.slice(0, 3) ],
              ...item.configList.slice(3)
            ]
            item.configList = _configList
          }
        }
        if (item._mode === MODE.FOUR) {
          item.configList = item.configList.slice(0, 1)
        }
        if (item._mode === MODE.THREE) {
          let _configList = []
          if (item.configList.length) {
            let pos = -1
            item.configList.forEach((item, idx) => {
              if (idx % 2 === 0) {
                pos++
                _configList[pos] = []
              }
              _configList[pos].push({...item})
            })
          }
          item.configList = _configList
        }
        return item
      })
    }
    return data
  }).catch(_ => _)
}


function d () {}

export {
  queryPartListByKey,
  addPart,
  getPartDetail,
  editPart,
  deletePart,
  upPart,
  updatePartOrder,
  // queryCarouselList,
  queryPreivew
}